import { Component } from '@angular/core';
import { Extrainfo } from 'src/app/models/form/book-data';
import { FormDataService } from 'src/app/services/form-data.service';

@Component({
  selector: 'app-ef-other-details',
  templateUrl: './ef-other-details.component.html',
  styleUrls: ['./ef-other-details.component.scss']
})
export class EfOtherDetailsComponent {

  extrainfo:Extrainfo;

  
constructor (
  private formDataService : FormDataService ,  
  public formData : FormDataService
  ) 
  {

  this.extrainfo = formDataService.extrainfo;

}

}
